module.exports = __webpack_public_path__ + "static/media/goat-breaking-open-a-pumpkin.b41f5b94.png";